/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface PaymenTechnologies
 */
export class PaymenTechnologies {
    /**
     *
     * @type {string}
     * @memberof PaymenTechnologies
     */
    _id: string;
    /**
     *
     * @type {string}
     * @memberof PaymenTechnologies
     */
    namespace: string;
    /**
     *
     * @type {string}
     * @memberof PaymenTechnologies
     */
    type: string;
    /**
     *
     * @type {string}
     * @memberof PaymenTechnologies
     */
    authId: string;
    /**
     *
     * @type {string}
     * @memberof PaymenTechnologies
     */
    authPw: string;
    /**
     *
     * @type {string}
     * @memberof PaymenTechnologies
     */
    secretKey: string;
    /**
     *
     * @type {boolean}
     * @memberof PaymenTechnologies
     */
    sandbox: boolean;
    /**
     *
     * @type {boolean}
     * @memberof PaymenTechnologies
     */
    autoApprove: boolean;
}
